/**
 * Reservations 列表上的两个业主自住系统视图（2026-10-20 Owner Stays 并入 Reservations）。
 *
 * id 与 main-api 迁移 `c7d4e1a9b2f6_owner_stays_into_reservations.py` 里插入的 sys.view 固定 id 逐字一致
 * （dev / prod 同 id）。旧的 /owner-stays 链接跳到 Pending 视图；按 id 判断，不靠视图名（名字会被翻译 / 改名）。
 * 2026-10-22 去审核后 Pending 视图改名「Owner Stays Not in PMS」（main-api 迁移 e5b1c7a3d902；过滤不变，id 不变）。
 */
export const OWNER_STAYS_VIEW_ID = '7520100000000002001'
export const PENDING_OWNER_STAYS_VIEW_ID = '7520100000000002002'

/** 旧的 /owner-stays 页面（侧栏菜单已撤）跳到这里 */
export const PENDING_OWNER_STAYS_PATH = `/reservations?viewId=${PENDING_OWNER_STAYS_VIEW_ID}`
